// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncidentSeverity } from './IncidentSeverity';
import {
    IncidentSeverityFromJSON,
    IncidentSeverityFromJSONTyped,
    IncidentSeverityToJSON,
    IncidentSeverityToJSONTyped,
} from './IncidentSeverity';
import type { IncidentStatus } from './IncidentStatus';
import {
    IncidentStatusFromJSON,
    IncidentStatusFromJSONTyped,
    IncidentStatusToJSON,
    IncidentStatusToJSONTyped,
} from './IncidentStatus';

/**
 * 
 * @export
 * @interface Incident
 */
export interface Incident {
    /**
     * UUID that identifies the incident
     */
    incidentId: string;
    /**
     * unique string that represents the incident type
     */
    type: string;
    /**
     * Manufacturer code that represents the incident type
     */
    code?: string;
    /**
     * Human readable message that describes the incident
     */
    message: string;
    /**
     * 
     */
    severity: IncidentSeverity;
    /**
     * Worst severity the episode ever reached (sharpest escalation). `severity` is the CURRENT grade of the alarm; `maxSeverity` stays at the peak even after the alarm de-escalates or resolves. Use this for the worst-grade headline/lamp.
     * 
     */
    maxSeverity?: IncidentSeverity;
    /**
     * Indicates if the incident is currently active or has been resolved
     */
    active: boolean;
    /**
     * 
     */
    status: IncidentStatus;
    /**
     * Path the device or function that is affected by the incident
     */
    context: string;
    /**
     * Event that initiated this incident.
     */
    eventId?: string;
    /**
     * 
     */
    createdAt: Date;
    /**
     * 
     */
    updatedAt: Date;
    /**
     * 
     */
    closedAt: Date | null;
    /**
     * Advise how to fix or handle the incident
     */
    help?: string | null;
    /**
     * Last operator comment recorded against this incident's episode — populated from Acknowledge/Confirm/Reset audit events. Empty when no comment has been written yet.
     * 
     */
    comment?: string | null;
    /**
     * True if any AuditConditionAcknowledge event was recorded during this episode. Independent of `confirmed` — both can be true when the operator first acked, then confirmed.
     * 
     */
    acknowledged?: boolean;
    /**
     * True if any AuditConditionConfirm event was recorded during this episode.
     * 
     */
    confirmed?: boolean;
    /**
     * True if any AuditConditionReportedEventType (Essentim companion spec, ns=…;i=15001) event was recorded during this episode. Independent of `acknowledged` and `confirmed`. Sticky.
     * 
     */
    reported?: boolean;
    /**
     * Critical-high threshold currently configured for the source.
     */
    highHighLimit?: number;
    /**
     * Warning-high threshold currently configured for the source.
     */
    highLimit?: number;
    /**
     * Warning-low threshold currently configured for the source.
     */
    lowLimit?: number;
    /**
     * Critical-low threshold currently configured for the source.
     */
    lowLowLimit?: number;
    /**
     * Number of Part-9 ConditionBranches folded into this episode — i.e. how many times the alarm flapped (active→normal while un-acked) within the episode window. Only set when the source actually flapped (≥ MIN_FLAP_RUN); absent otherwise. Branches are NOT surfaced as separate incidents; they roll up here plus into the acknowledged/confirmed/reported flags.
     * 
     */
    flapCount?: number;
    /**
     * Whether this alarm needs an explicit Confirm to close (strict OPC-UA A&C: New→Ack→Confirm) or whether Acknowledge is the terminal action (New→Ack). Derived from the OPC-UA ConfirmedState presence (decided per alarm in the proxy installer). When false, the UI must not require/offer Confirm — Acknowledge alone closes the incident.
     * 
     */
    strictAudited?: boolean;
}



/**
 * Check if a given object implements the Incident interface.
 */
export function instanceOfIncident(value: object): value is Incident {
    if (!('incidentId' in value) || value['incidentId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('severity' in value) || value['severity'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('context' in value) || value['context'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('closedAt' in value) || value['closedAt'] === undefined) return false;
    return true;
}

export function IncidentFromJSON(json: any): Incident {
    return IncidentFromJSONTyped(json, false);
}

export function IncidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Incident {
    if (json == null) {
        return json;
    }
    return {
        
        'incidentId': json['incidentId'],
        'type': json['type'],
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'],
        'severity': IncidentSeverityFromJSON(json['severity']),
        'maxSeverity': json['maxSeverity'] == null ? undefined : IncidentSeverityFromJSON(json['maxSeverity']),
        'active': json['active'],
        'status': IncidentStatusFromJSON(json['status']),
        'context': json['context'],
        'eventId': json['eventId'] == null ? undefined : json['eventId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'closedAt': (json['closedAt'] == null ? null : new Date(json['closedAt'])),
        'help': json['help'] === undefined ? undefined : json['help'] === null ? null : json['help'],
        'comment': json['comment'] === undefined ? undefined : json['comment'] === null ? null : json['comment'],
        'acknowledged': json['acknowledged'] == null ? undefined : json['acknowledged'],
        'confirmed': json['confirmed'] == null ? undefined : json['confirmed'],
        'reported': json['reported'] == null ? undefined : json['reported'],
        'highHighLimit': json['highHighLimit'] == null ? undefined : json['highHighLimit'],
        'highLimit': json['highLimit'] == null ? undefined : json['highLimit'],
        'lowLimit': json['lowLimit'] == null ? undefined : json['lowLimit'],
        'lowLowLimit': json['lowLowLimit'] == null ? undefined : json['lowLowLimit'],
        'flapCount': json['flapCount'] == null ? undefined : json['flapCount'],
        'strictAudited': json['strictAudited'] == null ? undefined : json['strictAudited'],
    };
}

export function IncidentToJSON(json: any): Incident {
    return IncidentToJSONTyped(json, false);
}

export function IncidentToJSONTyped(value?: Incident | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'incidentId': value['incidentId'],
        'type': value['type'],
        'code': value['code'],
        'message': value['message'],
        'severity': IncidentSeverityToJSON(value['severity']),
        'maxSeverity': IncidentSeverityToJSON(value['maxSeverity']),
        'active': value['active'],
        'status': IncidentStatusToJSON(value['status']),
        'context': value['context'],
        'eventId': value['eventId'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'closedAt': value['closedAt'] == null ? value['closedAt'] : value['closedAt'].toISOString(),
        'help': value['help'],
        'comment': value['comment'],
        'acknowledged': value['acknowledged'],
        'confirmed': value['confirmed'],
        'reported': value['reported'],
        'highHighLimit': value['highHighLimit'],
        'highLimit': value['highLimit'],
        'lowLimit': value['lowLimit'],
        'lowLowLimit': value['lowLowLimit'],
        'flapCount': value['flapCount'],
        'strictAudited': value['strictAudited'],
    };
}

